import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormRushCounterField, {
  MxFormRushCounterFieldProps
} from "@rf-l2/form/rush/MxFormRushCounterField";
interface MxFormL3RushCounterFieldProps extends MxFormRushCounterFieldProps {
  name: string;
  withreacthookform?:1|0;
}
const MxFormL3RushCounterField = (props: MxFormL3RushCounterFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormRushCounterField {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default MxFormL3RushCounterField;
